"use client";

/** Fixed circuit-grain backdrop behind all pages. */
export function LegacyBackdrop() {
  return (
    <div className="site-backdrop" aria-hidden>
      <div className="site-backdrop-circuit" />
      <div className="site-backdrop-vignette" />
    </div>
  );
}
